import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import AccountAuth from "@/pages/account/AccountAuth";
import AccountDashboard from "@/pages/account/AccountDashboard";

const ADMIN_ROLES = ["admin", "super_admin"];

export default function AccountIndex() {
  const { user } = useAuth();
  if (user === null) return <div className="onusa-container py-40 text-center"><p className="label-x">LOADING…</p></div>;
  if (user && ADMIN_ROLES.includes(user.role)) return <Navigate to="/admin" replace />;
  return user ? <AccountDashboard /> : <AccountAuth />;
}
